import React from 'react'
import View from '../../document-viewer/TreatmentPlan/View'

const TreatmentPlan = () => {
  return <View />
}

export default TreatmentPlan
